import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Progress } from './ui/progress';
import HoverText from './HoverText';
import { FOREST_PROJECTS } from '../data/projectsData';

const Projects = () => {
  // IMMER die lokalen Projektdaten verwenden - garantiert aktuell
  const projects = FOREST_PROJECTS;
  const loading = false;

  const getStatusColor = (status) => {
    if (status.includes('Geschützt')) return 'bg-green-500';
    if (status === 'Aktiv') return 'bg-blue-500';
    if (status === 'Dringend') return 'bg-red-500';
    return 'bg-yellow-500';
  };

  const handleDonateClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleProjectClick = () => {
    handleDonateClick();
  };

  if (loading) {
    return (
      <section id="projects" className="py-24 md:py-40 bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">Projekte werden geladen...</div>
        </div>
      </section>
    );
  }

  return (
    <section id="projects" className="py-16 md:py-24 lg:py-32 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-left md:text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <HoverText 
            className="text-gray-900" 
            style={{ 
              fontFamily: "'Playfair Display', serif", 
              fontSize: 'clamp(28px, 5vw, 42px)', 
              fontWeight: 700,
              lineHeight: 1.2,
              textAlign: 'left',
              marginBottom: '16px'
            }}
          >
            Weltweit aktive Waldschutzprojekte
          </HoverText>
          <HoverText 
            className="text-gray-600" 
            style={{ 
              fontSize: 'clamp(16px, 3vw, 18px)', 
              fontWeight: 400, 
              color: '#666', 
              lineHeight: 1.6,
              textAlign: 'left',
              marginBottom: '16px'
            }}
          >
            Entdecken Sie die Wälder und ihre Bewohner, die wir gemeinsam schützen. Jedes Projekt rettet Lebensräume für unzählige Tierarten.
          </HoverText>
        </div>

        {/* CSS Grid mit auto-fill und minmax für automatischen Zeilenumbruch */}
        <div 
          className="projects-grid mb-12"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '20px'
          }}
        >
          {projects.map((project) => {
            const progressPercentage = (project.raised / project.goal) * 100;
            return (
              <div
                key={project.id}
                onClick={handleProjectClick}
                className="project-card group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-[#FF9B8C] cursor-pointer flex flex-col"
                style={{ height: '480px' }}
              >
                {/* Background Image - Feste Höhe */}
                <div className="relative h-56 overflow-hidden flex-shrink-0">
                  <img
                    src={project.image}
                    alt={project.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  
                  {/* Status Badge */}
                  <div className="absolute top-4 left-4">
                    <span className={`px-4 py-1.5 ${getStatusColor(project.status)} text-white text-xs font-semibold rounded-full shadow-lg`}>
                      {project.status}
                    </span>
                  </div>
                </div>

                {/* Content - Text teilweise versteckt */}
                <div className="p-6 bg-white flex-1 flex flex-col">
                  
                  {/* Titel - Immer sichtbar */}
                  <h3 className="text-xl font-bold text-gray-900 mb-4 line-clamp-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {project.name}
                  </h3>

                  {/* Beschreibung - Versteckt, nur beim Hover */}
                  <div className="flex-1 mb-4 overflow-hidden">
                    <p className="text-gray-600 text-sm leading-relaxed line-clamp-3 group-hover:line-clamp-none transition-all duration-300">
                      {project.description}
                    </p>
                  </div>

                  {/* Progress Bar - Immer sichtbar */}
                  <div className="space-y-2 mt-auto">
                    <div className="flex justify-between items-center">
                      <span className="text-xs font-semibold text-gray-700">
                        Finanzierung
                      </span>
                      <span className="text-lg font-bold text-[#FF1B8D]">
                        {progressPercentage.toFixed(0)}%
                      </span>
                    </div>
                    <Progress value={progressPercentage} className="h-2.5" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button
            onClick={handleDonateClick}
            className="bg-[#FF1B8D] hover:bg-[#E01679] text-white px-8 py-6 rounded-full text-lg font-semibold shadow-lg hover:shadow-xl"
          >
            Jetzt kontaktieren
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Projects;
